import { useEffect, useState } from 'react';
import { CustomDialogProps } from '@/dashboard/components/Dialog/index';
import DownloadFileView from '@/dashboard/components/Files/downloadFile';
import LogoLoading from '@/dashboard/components/loading/LogoLoading';
import PolicyModel from '@/dashboard/models/policys/PolicyModel';
import { GridItem } from '@/dashboard/mui/styledComponent';
import { globalDataStore } from '@/dashboard/store/globalDataStore';
import { apiGetPolicyDocumentInfo } from '@jove-frontend/uikit';
import { Box, Button, Grid, Typography } from '@mui/material';

type PolicyDocumentsDialogProps = CustomDialogProps & {
  policy: PolicyModel;
};

const PolicyDocumentsDialog = (props: PolicyDocumentsDialogProps) => {
  const { policy, close } = props;
  const [loading, setLoading] = useState(false);
  const [masterDocumentList, setMasterDocumentList] = useState([]);
  const [individualDocumentList, setIndividualDocumentList] = useState([]);
  const {
    state: { queryParams },
  } = globalDataStore();

  /**
   * request
   */
  const requestPolicyDocumentInfo = async () => {
    const params = {
      policy_id: policy.id,
      user_id: queryParams?.queryUserId,
    };
    setLoading(true);
    const [res] = await apiGetPolicyDocumentInfo(params);
    setLoading(false);
    if (res) {
      const list = res.data ?? [];
      setMasterDocumentList(
        list.filter((item) => item.title === 'Insurance Policy Document')
      );
      setIndividualDocumentList(
        list.filter((item) => item.title !== 'Insurance Policy Document')
      );
    }
  };

  /**
   * effects
   */
  useEffect(() => {
    requestPolicyDocumentInfo();
  }, []);

  const closeAction = () => {
    if (close) close();
  };

  return (
    <Box className="flex flex-col">
      {loading && <LogoLoading />}
      <Typography className="mt-4 font-bold" variant="h5">
        Policy documents
      </Typography>
      {masterDocumentList.length > 0 && (
        <>
          <Typography
            className="text-black-secondary mt-4 text-lg font-bold"
            variant="subtitle1"
          >
            Master document
          </Typography>
          <Typography
            className="text-black-secondary mt-3 font-medium"
            variant="subtitle2"
          >
            This is your master insurance document that contains: policy
            schedule, statement of fact, summary of cover, policy wording and
            certificate of insurance.
          </Typography>
          <Box className="mt-3 flex flex-col">
            {masterDocumentList.map((item, index) => {
              return (
                <DownloadFileView
                  key={index}
                  className="border-grey-29 rounded-lg border"
                  info={item}
                />
              );
            })}
          </Box>
        </>
      )}
      {individualDocumentList.length > 0 && (
        <>
          <Typography
            className="text-black-secondary my-4 text-lg font-bold"
            variant="subtitle1"
          >
            Individual documents
          </Typography>
          <Grid container spacing={2} className="relative min-h-[150px]">
            {individualDocumentList.map((item) => {
              return (
                <Grid key={item.url} item xs={12} md={6}>
                  <GridItem className="h-full">
                    <DownloadFileView
                      className="border-grey-29 rounded-lg border"
                      info={item}
                    />
                  </GridItem>
                </Grid>
              );
            })}
          </Grid>
        </>
      )}
      <Box className="flex flex-row justify-end">
        <Button
          className="mt-10 h-12 w-[120px] rounded-full text-lg font-bold"
          color="primary"
          variant="contained"
          onClick={closeAction}
        >
          Close
        </Button>
      </Box>
    </Box>
  );
};

export default PolicyDocumentsDialog;
